import { graphql, useStaticQuery } from 'gatsby';

const useLogos = () => {
  const data = useStaticQuery(
    graphql`
      query {
        logos: directusLogo {
          enable_right_footer_logo
          right_footer_logo {
            data {
              full_url
            }
          }
          left_footer_logo {
            data {
              full_url
            }
          }
          tenant_logo {
            data {
              full_url
            }
          }
        }
      }
    `
  );

  return {
    tenantLogoUrl: data?.logos?.tenant_logo?.data?.full_url,
    leftFooterLogoUrl: data?.logos?.left_footer_logo?.data?.full_url,
    rightFooterLogoUrl: data?.logos?.right_footer_logo?.data?.full_url,
    enableRightFooterLogo: data?.logos?.enable_right_footer_logo,
  };
};

export default useLogos;
